import $ from 'jquery';
import 'slick-carousel';

export default function product() {
    $('.gallery-main').slick({
        arrows: true,
        dots: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    arrows: false,
                    dots: false
                }                
            }
        ]
    });

    $('.gallery-thumbnails').slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        asNavFor: '.gallery-main',
        focusOnSelect: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow:3,
                }
            }
        ]
    });

    $('.gallery-customer').slick({
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow:2,
                    slidesToScroll:2,
                }
            },
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow:3,
                    slidesToScroll:3,
                }
            }
        ]
    })
}